export const PushbackType = Object.freeze({
    MISSING: 'missing',
    EXISTING: 'existing',
});

export const getSubmissionGradeSnapshot = (submission, assignment) => {
    if (!submission?.grading || !assignment?.ai_grading_enabled) return null;

    const gradeOverrides = submission.grade_overrides || {};
    const criteria = assignment?.rubric?.criteria || [];
    const score =
        gradeOverrides.total != null
            ? Number(gradeOverrides.total)
            : Object.entries(submission.grading.criteria || {}).reduce((total, [criterionId, optionId]) => {
                  if (gradeOverrides[criterionId] != null) return total + Number(gradeOverrides[criterionId]);
                  const criterion = criteria.find(({ id }) => `${id}` === `${criterionId}`);
                  const option = criterion?.options?.find(({ id }) => `${id}` === `${optionId}`);
                  return total + Number(option?.rate || 0);
              }, 0);
    const maxGrade = criteria.reduce(
        (total, criterion) => total + Math.max(0, ...(criterion.options || []).map(({ rate }) => Number(rate))),
        0
    );

    return {
        grade: score,
        max_grade: maxGrade,
        display_grade: `${score}/${maxGrade}`,
    };
};

export const getLatestPushbackRecord = (submission) => {
    const history = submission?.grade_pushback_history || [];
    return history.length ? history[history.length - 1] : null;
};

export const getSubmissionLmsSyncStatus = (submission, assignment) => {
    if (!submission?.grading) return null;

    const latest = getLatestPushbackRecord(submission);
    if (!latest) return 'needs_attention';

    const current = getSubmissionGradeSnapshot(submission, assignment);
    if (!current) return null;
    return Number(current.grade) === Number(latest.grade) && Number(current.max_grade) === Number(latest.max_grade)
        ? 'synced'
        : 'needs_attention';
};

export const getLmsSubmissionUserId = (submission) =>
    `${process.env.REACT_APP_KIND === 'CANVAS' ? submission.user_id : submission?.Entity?.EntityId}`;

export const isLmsSubmissionGraded = (submission) =>
    process.env.REACT_APP_KIND === 'CANVAS'
        ? submission?.workflow_state === 'graded'
        : Boolean(submission?.Feedback?.IsGraded);

export const selectSubmissionsForPushback = (submissions, lmsSubmissions, pushbackType) => {
    const eligibleUserIds = new Set(
        lmsSubmissions
            .filter((submission) =>
                pushbackType === PushbackType.EXISTING
                    ? isLmsSubmissionGraded(submission)
                    : !isLmsSubmissionGraded(submission)
            )
            .map(getLmsSubmissionUserId)
    );

    return submissions.filter((submission) => eligibleUserIds.has(`${submission?.api?.user?.id}`));
};
